export default __webpack_public_path__ + "static/media/Retirement Roadmap Pg3.fce39c1b.png";